/**
 * Get value from URL params for a certain key
 * @param {String} key URL params key to get
 */
export const getUrlParam = (key) => {
  const url = new URL(window.location.href);
  const search_params = new URLSearchParams(url.search);
  const param = search_params.get(key);

  if (param) {
    return param;
  }

  return;
};
